import React, { useEffect, useRef, useState } from 'react'

export interface UpdateAvatarModalProps {
  open: boolean
  onClose: () => void
  currentImage?: string | null
  onSave: (file: File) => Promise<void>
}

const UpdateAvatarModal: React.FC<UpdateAvatarModalProps> = ({ open, onClose, currentImage, onSave }) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const closeBtnRef = useRef<HTMLButtonElement>(null)
  const [file, setFile] = useState<File | null>(null)
  const [preview, setPreview] = useState<string | null>(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    if (open) {
      document.addEventListener('keydown', handleKeyDown)
      document.body.classList.add('modal-open')
      modalRef.current?.focus()
      setFile(null)
      setPreview(null)
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.classList.remove('modal-open')
    }
  }, [open, onClose])

  if (!open) return null

  const handleBackdrop = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0] || null
    setFile(f)
    if (f) {
      const reader = new FileReader()
      reader.onload = () => setPreview(reader.result as string)
      reader.readAsDataURL(f)
    } else {
      setPreview(null)
    }
  }

  const handleSave = async () => {
    if (!file) return
    setSaving(true)
    try {
      await onSave(file)
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose} />
      <div
        className="modal fade show d-block"
        role="dialog"
        tabIndex={-1}
        ref={modalRef}
        onMouseDown={handleBackdrop}
        style={{ overflow: 'auto' }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document" onMouseDown={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title w-100 text-center">Atualizar imagem</h5>
              <button type="button" className="btn-close" aria-label="Fechar" onClick={onClose} ref={closeBtnRef} />
            </div>
            <div className="modal-body text-center">
              <img
                src={preview || currentImage || '/assets/images/user.png'}
                alt="avatar"
                className="rounded-circle mb-3"
                style={{ width: 120, height: 120, objectFit: 'cover' }}
              />
              <input type="file" accept="image/*" className="form-control" onChange={handleChange} />
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-primary ms-auto text-white bg-primary" 
                onClick={handleSave} 
                disabled={!file || saving}
                style={{ border: 'none', }}
              >
                {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UpdateAvatarModal
